import { GradeLevelEnum } from '@lon/shared/gql/types';
import { colors, gradeLevelScoreConfig } from './constants';

export const getQuantileColor = ({
  quantileScore,
  gradeLevel,
}: {
  quantileScore: string;
  gradeLevel: GradeLevelEnum;
}) => {
  if (gradeLevel === GradeLevelEnum.GlPreK) {
    return null;
  }

  const score = parseInt(quantileScore);
  const config = gradeLevelScoreConfig[gradeLevel];

  if (!config) {
    return null;
  }

  switch (true) {
    case score >= config.red.min && score <= config.red.max:
      return colors[config.red.color];
    case score >= config.yellow.min && score <= config.yellow.max:
      return colors[config.yellow.color];
    case score >= config.blue.min && score <= config.blue.max:
      return colors[config.blue.color];
    case score >= config.green.min && score <= config.green.max:
      return colors[config.green.color];
    default:
      return null;
  }
};
